import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { DashboardReportingQueryTypes, IReportDateRange, ReportDao } from '../../../../core/services/dao/reportDao';
import { Brand } from '../../../../core/models/brand';
import { ChartType } from 'chart.js';
import {DemoConstants} from '../../../../assets/data/demoConstants'

@Component({
  selector: 'traffic-by-affiliate-tile',
  templateUrl: './traffic-by-affiliate-tile.component.html',
  styleUrls: ['traffic-by-affiliate-tile.component.scss']
})
export class TrafficByAffiliateTileComponent implements OnInit, OnDestroy {
  dateRangeSubscription: Subscription;
  @Input() brand: Brand;
  @Input() creatives: Array<string> = [];
  public currentDateRange: IReportDateRange;
  private subs: any[] = [];
  public loadingData = true;
  public chartType: ChartType = 'bar';
  public chartData: any = { series: [], labels: [] };
  // public chartOpts: BarChartOptions = {};
  // public chartEvents: ChartEvent = {};
  public displayField = 'lift';
  public selectedCreative = 'All';
  private currentLabels = [];
  private listener;

  private reportData = [];

  constructor() {}

  ngOnInit() {
    this.reportData = DemoConstants.trafficMicroMomentAll
    this.loadingData = false;
    this.setChartData(this.reportData);
  }

  addLabelEventListeners() {
    ///clear all current listeners first
    this.currentLabels.forEach(el => {
      el.removeEventListener('mouseover', this.handleLabelHover);
      el.removeEventListener('mouseout', this.handleLabelOut);
    });
    /// label does not show tooltip by default. add the show class any time label is hovered.
    let labels = document.getElementsByClassName('bar-label');
    for (let i = 0; i < labels.length; i++) {
      let el = labels.item(i);
      this.currentLabels.push(el);
      el.addEventListener('mouseover', this.handleLabelHover);
      el.addEventListener('mouseout', this.handleLabelOut);
    }
  }

  handleLabelHover(evt) {
    let tooltip = document.getElementsByClassName('chartist-tooltip').item(0);
    tooltip.classList.add('tooltip-show');
  }

  handleLabelOut(evt) {
    let tooltip = document.getElementsByClassName('chartist-tooltip').item(0);
    tooltip.classList.remove('tooltip-show');
  }

  changeDisplayValue(evt) {
    this.displayField = evt.value;
    this.setChartData(this.reportData);
    setTimeout(() => {
      this.addLabelEventListeners();
    }, 500);
  }

  changeSelectedCreative(evt) {
    this.selectedCreative = evt.value;
    switch (this.selectedCreative) {
      case 'TEST1':
        this.reportData = DemoConstants.test1Traffic;
        break;
      case 'TEST2':
        this.reportData = DemoConstants.test2Traffic;
        break;
      case 'TEST3':
        this.reportData = DemoConstants.test3Traffic;
        break;
      case 'TEST4':
        this.reportData = DemoConstants.test4Traffic;
        break;
      case 'TEST5':
        this.reportData = DemoConstants.test5Traffic;
        break;
      case 'TEST6':
        this.reportData = DemoConstants.test6Traffic;
        break;
      default:
        this.reportData = DemoConstants.trafficMicroMomentAll;
        break;
    }
    this.setChartData(this.reportData);
  }

  setChartData(chartData: Array<any>) {
    this.chartData.labels = [];
    this.chartData.series = [];

    let data = [];
    let series = [];
    for (let record of chartData) {
      let val = 0;
      switch (this.displayField) {
        case 'sessions':
          val = parseFloat(record.avgSessions.toFixed(1));
          break;
        case 'lift':
          val = this.roundPctLift(record.avgPctLift);
          break;
        case 'pageviews':
          val = parseFloat(record.avgPv.toFixed(1));
          break;
      }
      data.push({
        label: record.affiliate,
        meta: `<div style="text-align: start">${
          record.airingCount
        } airings</div> <div style="text-align: start">${this.roundPctLift(record.avgPctLift)}% average lift</div>`,
        value: val
      });
    }

    data
      .sort((a, b) => {
        return b.value - a.value;
      })
      .slice(0, 8)
      .sort((a, b) => {
        if (a.label < b.label) return -1;
        if (b.label < a.label) return 1;
        return 0;
      })
      .forEach(record => {
        //@ts-ignore
        this.chartData.labels.push(record.label);
        series.push(record);
      });

    let max = Math.max(...series);
    let ticks = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    for (let i = 20; i <= Math.ceil(max / 10) * 10; i += 10) {
      ticks.push(i);
    }
    // this.chartOpts = {
    //   axisX: {
    //     showGrid: false
    //   },
    //   axisY: {
    //     showLabel: false,
    //     showGrid: false,
    //     type: Chartist.FixedScaleAxis,
    //     ticks: ticks
    //   },
    //   seriesBarDistance: 50,
    //   scales: {
    //     yAxes: [
    //       {
    //         ticks: {
    //           beginAtZero: true
    //         }
    //       }
    //     ]
    //   },
    //   chartPadding: { top: 10, right: 0, left: -30, bottom: 0 },
    //   plugins: [
    //
    //   ]
    // } as BarChartOptions;
    this.chartData.series[0] = series;
    // this.chartEvents = {
    //   draw: (data: any) => {
    //     ///add label to bar
    //     if (data.type === 'bar') {
    //       //if too small to hold label, make the bar a little taller
    //       if (data.y1 - data.y2 < 25) {
    //         data.element.attr({
    //           y2: data.y2 - 20
    //         });
    //         data.y2 = data.y2 - 20;
    //       }
    //       data.element._node.style.strokeWidth = '35px';
    //       let txt;
    //       if (this.displayField === 'lift') {
    //         txt = data.value.y + '%';
    //       } else {
    //         txt = data.value.y;
    //       }
    //
    //       data.group
    //         .elem(
    //           'text',
    //           {
    //             // This gets the top point of the bars and then adds enough room for label
    //             x: data.x1,
    //             y: data.y2 + 15,
    //             style: 'text-anchor: middle; fill: white; cursor: default'
    //           },
    //           'bar-label'
    //         )
    //         .text(txt);
    //     }
    //   }
    // };
  }

  private roundPctLift(lift: number): number {
    return parseInt((lift * 100).toFixed(0));
  }

  chartInitialized(chart) {
    this.listener = window.matchMedia('print').addEventListener('change', () => {
      chart.update();
    });
  }

  ngOnDestroy() {
    if (this.listener) {
      window.matchMedia('print').removeEventListener('change', this.listener);
    }
    this.subs.forEach(sub => {
      sub.unsubscribe();
    });
  }
}
